<template>
  <div class="w-100">
    <div class="" v-for="(product,product_i) in products">
      <div class="row no-gutters mb-3" :class="{'pb-3 border-b-form-dashed-2' : product_i + 1 < products.length}">
        <div class="col-8 text-left" @click="togglePopupDetail(product)">
          <p class="mb-1 body-2-4">{{product.name}}</p>
          <p class="mb-0 body-3">{{product.module}}</p>
          <p class="mb-0 body-3" v-if="$isNotEmpty(product.other)">{{ product.other }}</p>
          <div class="w-100 mt-1" v-if="product.promotion.promotionName">
            <div :id="`product-promo-${product.id}`" class="d-inline-flex mw-100 overflow-hidden align-items-center py-1 px-2 radius-12 border-green cursor-help" style="background-color: var(--merchant-primary-color-alpha);">
              <svg class="flex-shrink-0" width="14" height="14" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0328 5.47928L13.5429 5.98928C13.9468 6.38594 14.1665 6.92428 14.1665 7.49094C14.1736 8.05761 13.9539 8.59665 13.5571 8.99969C13.5524 9.00489 13.5477 9.00945 13.5429 9.01402C13.5406 9.0163 13.5382 9.01858 13.5359 9.02094L13.0328 9.52386C12.8343 9.72219 12.721 9.99136 12.721 10.2754V11.0043C12.721 12.1801 11.7644 13.1371 10.5881 13.1371H9.85827C9.57483 13.1371 9.30557 13.2497 9.10717 13.448L8.59698 13.958C8.17891 14.3767 7.6333 14.5814 7.08768 14.5814C6.54207 14.5814 5.99646 14.3767 5.57839 13.9658L5.06112 13.448C4.86271 13.2497 4.59345 13.1371 4.31001 13.1371H3.58016C2.4039 13.1371 1.44731 12.1801 1.44731 11.0043V10.2754C1.44731 9.99136 1.33393 9.72219 1.13553 9.51678L0.625342 9.01386C-0.203708 8.18582 -0.210794 6.83219 0.618256 5.99707L1.13553 5.47928C1.33393 5.28094 1.44731 5.01178 1.44731 4.72136V3.99886C1.44731 2.82303 2.4039 1.86749 3.58016 1.86749H4.31001C4.59345 1.86749 4.86271 1.75344 5.06112 1.55511L5.5713 1.04511C6.40035 0.209987 7.75376 0.209987 8.58989 1.03874L9.10717 1.55511C9.30557 1.75344 9.57483 1.86749 9.85827 1.86749H10.5881C11.7644 1.86749 12.721 2.82303 12.721 3.99886V4.72915C12.721 5.01178 12.8343 5.28094 13.0328 5.47928ZM5.2586 9.94171C5.42866 9.94171 5.58455 9.87796 5.69793 9.75754L9.34008 6.11741C9.581 5.87658 9.581 5.47921 9.34008 5.23837C9.09916 4.99825 8.70943 4.99825 8.46851 5.23837L4.82636 8.87921C4.58544 9.12004 4.58544 9.51671 4.82636 9.75754C4.93973 9.87796 5.09562 9.94171 5.2586 9.94171ZM8.28428 9.31837C8.28428 9.66546 8.56063 9.94171 8.90784 9.94171C9.24796 9.94171 9.52431 9.66546 9.52431 9.31837C9.52431 8.97908 9.24796 8.70212 8.90784 8.70212C8.56063 8.70212 8.28428 8.97908 8.28428 9.31837ZM5.26661 5.06136C5.60673 5.06136 5.88308 5.33761 5.88308 5.67761C5.88308 6.0254 5.60673 6.30095 5.26661 6.30095C4.92648 6.30095 4.64305 6.0254 4.64305 5.67761C4.64305 5.33761 4.92648 5.06136 5.26661 5.06136Z" class="fill-primary"></path>
              </svg>
              <span class="lh-1 body-3-1 ml-1 d-block text-truncate" style="min-width:0">{{ product.promotion.promotionName }}</span>
            </div>
            <b-tooltip :target="`product-promo-${product.id}`" placement="top" :title="product.promotion.discountText">
            </b-tooltip>
          </div>
         <p v-if="product.form_flight_number !== 'HIDE'" class="text-12 mt-1 mb-0 cursor-pointer"><span class="font-lato-regular">Flight Number : </span> <span class="font-lato underline">{{ $isNotEmptyV2(product.flight_number) ? product.flight_number : "click to add" }}</span></p>
        </div>
        <div class="col-4 text-right">
          <p class="text-12 font-lato mb-0 text-subcolor text-line-through" v-if="product.promotion.promotionName">{{ $formatCurrency(product.price.baseWithTax) }}</p>
          <p class="text-14 font-lato mb-1 text-semi-dark">{{ $formatCurrency(product.price.finalWithTax) }}</p>
          <p class="mb-0 body-3">{{product.qty}} {{ product.unit ? product.unit : 'x' }}</p>
          <p v-if="!hideRemove" class="mb-0 body-2-4 text-danger underline cursor-pointer" @click="removeProduct(product)">{{$t('hotel.remove')}}</p>
        </div>
      </div>
    </div>

    <b-modal 
      v-model="showPopupDetail" 
      @hidden="togglePopupDetail()"
      ref="product_detail" 
      centered size="sm" hide-header hide-footer body-class="p-3" footer-class="p-0">
      <div class="w-100">
        <div v-if="$isNotEmptyV2(popupData)" class="w-100 mb-3 pb-3 border-b-form d-flex justify-content-between addt_srv_cart">
          <div class="image">
            <img :src="popupData.image_url" class="img-fit" >
          </div>
          <div class="w-100 px-3">
            <p class="mb-0 body-2-4">{{popupData.name}}</p>
            <div class="d-flex align-items-center mb-1 ">
              <p class="text-12 font-lato mb-0">{{ $formatCurrency(popupData.price.finalWithTax) }}</p>
              <p class="text-10 font-lato-regular mb-0 text-line-through ml-2" v-if="popupData.promotion.promotionName">{{ $formatCurrency(popupData.price.baseWithTax) }}</p>
            </div>
            <p class="mb-0 body-3">{{popupData.qty}} {{ popupData.unit ? popupData.unit : 'x' }}</p>
          </div>
        </div>
        <div class="w-100 mb-3 pb-3 border-b-form">
          <p class="mb-2 body-3-1">Flight Number :</p>
          <input 
            type="text" 
            class="px-3 py-2 font-lato text-14 w-100 radius-6"  
            :class="$v.flightNumberInput.$error ? 'border-danger' : 'border-form'"
            v-model="flightNumberInput" >
          <span v-if="$v.flightNumberInput.$error" class="mb-0 text-10 font-lato text-danger">Flight number is requried</span>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <button class="w-50 mr-1 g-btn g-btn-light g-btn-md" @click="togglePopupDetail()">Close</button>
          <button class="w-50 ml-1 g-btn g-btn-primary g-btn-md" @click="saveFlightNumber()">Save</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';
  import { validationMixin } from "vuelidate";
  import { isEmpty } from 'lodash';
  const { helpers } = require("vuelidate/lib/validators");

  const skipIfNoRequiredPopup = (detail) => {
    return helpers.withParams({ type: "skipIfNoRequiredPopup" }, function (value, parentVm) {
      if(isEmpty(detail)) return true;
      const isRequired = detail.form_flight_number === 'REQUIRED';
      return isRequired && isEmpty(value) ? false : true;
    });
  }
  
  const skipIfNoRequiredList = () => {
    return helpers.withParams({ type: "skipIfNoRequiredList" }, function (value, parentVm) {
      if(isEmpty(parentVm)) return true;
      const isRequired = parentVm.form_flight_number === 'REQUIRED';
      return isRequired && isEmpty(value) ? false : true;
    });
  }
  
  export default {
    props: ['products', 'hideRemove'],
    data(){
      return {
        showPopupDetail: false,
        popupData: null,
        flightNumberInput: ""
      }
    },
    computed:{
      totalProduct(){
        return this.products.length;
      },
      generalValidation(){
        return this.getAdditionalServiceValidation
      }
    },
    watch:{
      totalProduct(newData, oldData){
        if(oldData < newData){
          this.$v.products.$reset();
        }
      },
      generalValidation(newData, oldData){
        if(newData === 'START'){
          this.validateFlightNumberInList();
        }
      }
    },
    mixins: [validationMixin],
    validations(){
      return {
        flightNumberInput:{
          skipIfNoRequiredPopup: skipIfNoRequiredPopup(this.popupData || {})
        },
        products:{
          $each:{
            flight_number: {
              skipIfNoRequiredList: skipIfNoRequiredList()
            }
          }
        }
      }
    },
    methods:{
      ...mapMutations(['BeSaveOtherDataAddtService']),
      togglePopupDetail(data=null){
        if(data === null){
          this.showPopupDetail = false;
          this.flightNumberInput = "";
          this.popupData = null;
        }else{
          if(data.form_flight_number === "HIDE") return;
          this.showPopupDetail = true;
          this.popupData = this.$deepCopy(data);
          this.flightNumberInput = this.popupData.flight_number
        }
      },
      removeProduct(product){
        this.$emit('removeProduct', product)
      },
      validateFlightNumberInList(){
        this.$v.products.$reset();
        this.$v.products.$touch();

        const isValid = !this.$v.products.$invalid

        if(!isValid){
          const indexNotValid = Object.values(this.$v.products.$each.$iter).findIndex(parent => parent.$error);
          if(indexNotValid != -1){
            const roomRateSelected = this.products[indexNotValid];
            this.togglePopupDetail(roomRateSelected);
            setTimeout(() => {
              this.validateFlightNumber();
            }, 300);
          }
        }
        
        return isValid;
      },
      validateFlightNumber(){
        this.$v.flightNumberInput.$reset();
        this.$v.flightNumberInput.$touch();
        return !this.$v.flightNumberInput.$invalid;
      },
      
      saveFlightNumber(){
        if(!this.validateFlightNumber()) return;
        
        const payload = {
          key: 'flight_number',
          value: this.flightNumberInput,
          detail: this.popupData.ref_data.data
        }
        this.BeSaveOtherDataAddtService(payload);
        setTimeout(() => {
          this.togglePopupDetail();
        }, 200);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/additionalService/ProductCartWhiteStyle.vue